import React, { useState, useEffect } from "react";
// material
import {
    Card,
    Divider,
    Table,
    Button,
    Checkbox,
    TableRow,
    TableBody,
    TableCell,
    TextField,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    Modal,
    Box,
    TableSortLabel,
    Grid,
} from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import { UserListHead } from "src/sections/@dashboard/user";
import axios from "axios";
import { apiHeader } from "src/redux/actions/ApiHeader";
import { baseUrlPostGres } from "src/redux/constant";
import { toast } from "react-toastify";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { Edit, Delete } from "@mui/icons-material";
import { CKEditor } from "ckeditor4-react";
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: "c_no", label: "Sr no.", alignRight: false },
    { id: "c_title", label: "Title", alignRight: false },
    { id: "c_alt", label: "Alt Tag", alignRight: false },
    { id: "c_action", label: "Action", alignRight: false },
];

const POPUP_TABLE_HEAD = [
    { id: "c_no", label: "Sr no.", alignRight: false },
    { id: "c_id", label: "Title", alignRight: false },
    { id: "c_des", label: "Description", alignRight: false },
];

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    maxHeight: '100vh',
    overflow: 'scroll',
};

export const SeaportEObjective = () => {
    const [state, setState] = useState();
    const [state1, setState1] = useState();
    const [InputImagestate, setInputImageState] = useState({
        image: null,
        icon: null,
    });
    const [PopUpstate, setPopUpstate] = useState({});

    //open mode
    const [open, setopen] = useState("");

    const handleClose = () => {
        setopen(false);
        setInputImageState({});
    };

    const handleOpen = () => {
        setopen(true);
    };

    const [Error, setError] = useState("");

    const [updateModelopen, setupdateModelopen] = useState("");

    // const [updateModeldata, setupdateModeldata] = useState()

    const handleUpdateModelClose = () => {
        setInputImageState({});
        setPopUpstate();
        setupdateModelopen(false);
    };

    const handleUpdateModelOpen = () => {
        setupdateModelopen(true);
    };

    const UpdatePopUpSubmitData = async (e) => {
        setPopUpstate({});
        setInputImageState("");
        let formData = new FormData();
        formData.append("id", PopUpstate.id);
        formData.append("image", PopUpstate.image);
        formData.append("alt_tag", PopUpstate.alt_tag);
        formData.append("description", PopUpstate.description);
        setupdateModelopen(false);
        await axios
            .put(`${baseUrlPostGres()}/api/seaporte-obj-details-update`, formData, {
                headers: apiHeader(),
            })
            .then((response) => {
                listCalling1();
                toast("Content Added successfully");
            })
            .catch((errors) => {
                toast(errors);
            });
        // }
    };

    const openhandleUpdateModel = (ele) => {
        setPopUpstate(ele);
        handleUpdateModelOpen(true);
    };


    function getBase64(file, name) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () =>
                resolve(
                    setInputImageState({ ...InputImagestate, [name]: reader.result }),
                );
            reader.onerror = (error) => reject(error);
        });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "image" || name === "icon") {
            var file = e.target.files[0];
            setPopUpstate({ ...PopUpstate, [name]: file });
            getBase64(file, name);
        } else {
            setPopUpstate({ ...PopUpstate, [name]: value });
        }
    };


    useEffect(() => {
        listCalling();
        listCalling1();
    }, []);

    const listCalling = () => {
        axios
            .get(`${baseUrlPostGres()}/api/seaporte-objective-list`, {
                headers: apiHeader(),
            })
            .then((response) => {
                console.log(
                    "GetUpcomingMatchListAction Response is",
                    response.data.success[0],
                );
                setState1(response.data.success[0]);
            })
            .catch((errors) => {
                console.log("user list error", errors);
            });
    };
    const listCalling1 = () => {
        axios
            .get(`${baseUrlPostGres()}/api/seaporte-obj-details-list`, {
                headers: apiHeader(),
            })
            .then((response) => {
                setState(response.data.success);
            })
            .catch((errors) => {
                console.log("user list error", errors);
            });
    };

    const changeState1 = (e) => {
        // setState1({ ...state1, [e.target.name]: e.target.value });
        const name = e.editor.name;
        console.log(state1, "state1");
        const value = e.editor.getData()
        if (name === "content_description" || name === "description" || name === "head_line") {
            // setstate1({ ...state1, [name]: value })
            state1[name] = value
            setState1({ ...state1 })
        }
    };
    const UpdateState1SubmitData = async () => {
        let objData = {
            id: state1.id,
            head_line: state1.head_line,
        }

        await axios
            .put(`${baseUrlPostGres()}/api/seaporte-objective-update`, objData, {
                headers: apiHeader(),
            })
            .then((response) => {
                listCalling();
                toast("Content Added successfully");
            })
            .catch((errors) => {
                console.log("user list error", errors);
            });
    };

    return (
        <Page title="User">
            <Modal
                open={updateModelopen}
                onClose={handleUpdateModelClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Page title="User">
                        <Container maxWidth="lg">
                            <Scrollbar>
                                <TableContainer sx={{ minWidth: 800 }}>
                                    <Table>
                                        <UserListHead headLabel={POPUP_TABLE_HEAD} />
                                        {PopUpstate && (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        1
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        Banner Image
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <TextField
                                                            type="file"
                                                            accept="video/*"
                                                            name="image"
                                                            onChange={handleChange}
                                                            style={{ width: "100%" }}
                                                            sx={{
                                                                ".MuiOutlinedInput-root": {
                                                                    paddingTop: "1rem",
                                                                    flexDirection: "column",
                                                                },
                                                                img: {
                                                                    paddingRight: "1rem",
                                                                    height: "100px",
                                                                },
                                                            }}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <img
                                                                        alt=""
                                                                        src={
                                                                            PopUpstate.image != null &&
                                                                            `${baseUrlPostGres()}/${PopUpstate.image}`
                                                                        }
                                                                    />
                                                                ),
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        2
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        Banner Alt Tag
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <TextField
                                                            value={PopUpstate.alt_tag}
                                                            name="alt_tag"
                                                            style={{ width: "100%" }}
                                                            onChange={handleChange}
                                                        />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        3
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        Title
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <TextField
                                                            value={PopUpstate.description}
                                                            name="description"
                                                            inputProps={{
                                                                // maxLength: 300,
                                                            }}
                                                            style={{ width: "100%" }}
                                                            onChange={handleChange}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </TableContainer>
                            </Scrollbar>
                            <Button
                                variant="contained"
                                style={{ margin: "20px" }}
                                alignRight="true"
                                onClick={UpdatePopUpSubmitData}
                            >
                                Submit
                            </Button>
                            <Button
                                variant="contained"
                                style={{ margin: "20px" }}
                                alignRight="true"
                                onClick={handleUpdateModelClose}
                            >
                                Cancel
                            </Button>
                        </Container>
                    </Page>
                </Box>
            </Modal>
            <Container maxWidth="lg">
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                        <Grid
                            xs={12}
                            style={{ display: "flex", justifyContent: "space-between" }}
                        >
                            <HeaderBreadcrumbs
                                heading="Quality Objectives CMS"
                                links={[
                                    { name: "Dashboard", href: "/dashboard" },
                                    { name: "Quality Objectives Cms" },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Scrollbar>
                    <Table>
                        {state1 && (
                            <>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        1
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        Head Line
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {state1.head_line && <div className="App">
                                            <CKEditor
                                                name="head_line"
                                                initData={state1.head_line}
                                                onChange={changeState1}
                                            />
                                        </div>}
                                    </TableCell>
                                </TableRow>
                            </>
                        )}
                    </Table>
                    <Button
                        variant="contained"
                        style={{ margin: "20px" }}
                        alignRight="true"
                        onClick={UpdateState1SubmitData}
                    >
                        Submit
                    </Button>
                    <TableContainer sx={{ minWidth: 800 }}>
                        <Table>
                            <UserListHead headLabel={TABLE_HEAD} />
                            {state &&
                                state.map((ele, i) => {
                                    return (
                                        <>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {i + 1}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <TextField
                                                            value={ele.description}
                                                            name="description"
                                                            style={{ width: "100%" }}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <TextField
                                                            value={ele.alt_tag}
                                                            name="alt_tag"
                                                            style={{ width: "100%" }}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            onClick={() => openhandleUpdateModel(ele)}
                                                        >
                                                            <Edit />
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </>
                                    );
                                })}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Container>
        </Page>
    );
};
